import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { getSubscriptions } from "../../api/userApi";
import { dispatchAlertError } from "../../app/godispatch";
import { makeid } from "../../app/utils";
import Loading from "../component/Loading";
import UserLayout from "../component/UserLayout";
import './UserSubscriptionPage.css';

export default function UserSubscriptionPage() {
    document.title = '我的订阅'
    const [validList, setValidList] = useState([])
    const [invalidList, setInvalidList] = useState([])
    const [loading, setLoading] = useState(false)
    const initParam = {
        valid: true,
        pageNo: 0,
        pageSize: 8,
        last: false
    }
    const [validParam, setValidParam] = useState({ ...initParam })
    const [invalidParam, setInvalidParam] = useState({ ...initParam, valid: false })

    useEffect(() => {
        query(validParam)
        query(invalidParam)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const query = (param) => {
        if (param.last) return
        getSubscriptions(param)
            .then((res) => {
                if (param.valid) {
                    setValidList(validList.concat(res.data.content))
                    setValidParam(prev => ({
                        ...prev,
                        last: res.data.last,
                        pageNo: res.data.last ? param.pageNo : param.pageNo + 1
                    }))
                } else {
                    setInvalidList(invalidList.concat(res.data.content))
                    setInvalidParam(prev => ({
                        ...prev,
                        last: res.data.last,
                        pageNo: res.data.last ? param.pageNo : param.pageNo + 1
                    }))
                }
            })
            .catch((e) => {
                dispatchAlertError(e.message || '查询失败请稍后再试')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const loadMore = (valid) => {
        if (loading) return
        if (valid) {
            query(validParam)
        } else {
            query(invalidParam)
        }
    }

    const LoadMoreComponent = ({ param }) => {
        return (
            <Row className="moreRow" onClick={() => loadMore(param.valid)}>
                <Col className="d-flex align-items-center justify-content-center">
                    {!param.last && '加载更多'}
                    {param.last && '没有更多了'}
                </Col>
            </Row>
        )
    }

    return (
        <UserLayout>
            <Container className="allStyle">
                <Row>
                    <Col>
                        <Tabs
                            defaultActiveKey={1}
                            id="fill-tab-example"
                            className="tabsStyle"
                            fill
                        >
                            <Tab eventKey={1} title="有效订阅">
                                {loading && <Loading />}
                                {!loading &&
                                    validList.map(item => {
                                        return <Row key={makeid(5)} className="itemRow">
                                            <Col xs={1} className="hinterValid"></Col>
                                            <Col xs={4} className="itemCol d-flex align-items-center justify-content-center">
                                                {item.type}
                                            </Col>
                                            <Col xs={7} className="itemCol d-flex align-items-center justify-content-center">
                                                过期日期：{moment(item.expireTime).format('YYYY-MM-DD')}
                                            </Col>
                                        </Row>
                                    })
                                }
                                <LoadMoreComponent param={validParam} />
                            </Tab>
                            <Tab eventKey={0} title="已无效订阅">
                                {loading && <Loading />}
                                {!loading &&
                                    invalidList.map(item => {
                                        return <Row key={makeid(5)} className="itemRowInvalid">
                                            <Col xs={1} className="hinterInvalid"></Col>
                                            <Col xs={4} className="itemCol d-flex align-items-center justify-content-center">
                                                {item.type}
                                            </Col>
                                            <Col xs={7} className="itemCol d-flex align-items-center justify-content-center">
                                                过期日期：{moment(item.expireTime).format('YYYY-MM-DD')}
                                            </Col>
                                        </Row>
                                    })
                                }
                                <LoadMoreComponent param={invalidParam} />
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </UserLayout>
    )
}
